import { useState, useEffect } from "react";

function TimeAgoMinutes(props) {
    const { timestamp } = props;

    const [minutesAgo, setMinutesAgo] = useState(() =>
        Math.floor((Date.now() - timestamp) / 60000)
    );

    useEffect(() => {
        const updateMinutes = () => {
            setMinutesAgo(
                Math.floor((Date.now() - timestamp) / 60000)
            );
        };

        updateMinutes();

        const interval = setInterval(updateMinutes, 1000);

        return () => clearInterval(interval);
    }, [timestamp]);

    return <>{minutesAgo}</>;
}

export default TimeAgoMinutes;